import { FEATURE_NAMES } from '../../loaders/features/features';
export const LOG_LEVELS = {
  ERROR: 'ERROR',
  WARN: 'WARN',
  INFO: 'INFO',
  DEBUG: 'DEBUG',
  TRACE: 'TRACE'
};
export const LOGGING_EVENT_EMITTER_CHANNEL = 'log';
export const FEATURE_NAME = FEATURE_NAMES.logging;